(function () {
    'use strict';

    angular
        .module('franchisee-portal.interceptors')
        .factory('authenticationFactory', AuthenticationFactory)

    /** @ngInject */
    function AuthenticationFactory($q, $rootScope, AUTH_EVENTS, LOCAL_STORAGE_ITEMS) {
        return {
            request: request,
            responseError: responseError
        }

        function request(config) {
            const accessToken = localStorage.getItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN);

            if (accessToken) {
                Object.assign(config.headers, {
                    'Authorization': 'Bearer ' + accessToken
                });
            }

            return config;
        }

        function responseError(response) {
            $rootScope.$broadcast({
                401: AUTH_EVENTS.NOT_AUTHENTICATED
            } [response.status], response);

            return $q.reject(response);
        }
    }
}());